/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .colored-text[_ngcontent-%COMP%]{padding:1.25em;color:#fff;font-size:1.5em;font-weight:500;border-radius:6px;word-break:break-word;display:flex;justify-content:center;align-items:center;min-height:306px;text-align:center}"];
export { styles as styles };
